import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const fetchInvoiceById = createAsyncThunk(
  "tally/fetchInvoiceById",
  async (invoiceId, toolkit) => {
    const response = await AxiosClient(
      "GET",
      `/invoice/get-invoice/${invoiceId}`,
      [],
      toolkit
    );
    return response?.payload?.data;
  }
);

export const fetchCreditNoteById = createAsyncThunk(
  "tally/fetchCreditNoteById",
  async (creditNoteId, toolkit) => {
    const response = await AxiosClient(
      "GET",
      `/invoice/credit-note/${creditNoteId}`,
      [],
      toolkit
    );
    return response?.payload?.data;
  }
);

export const fetchReceiptById = createAsyncThunk(
  "tally/fetchReceiptById",
  async (receiptId, toolkit) => {
    const response = await AxiosClient(
      "GET",
      `/receipt/get-receipt/${receiptId}`, 
      [],
      toolkit
    );
    return response?.payload?.data;
  }
);

export const createTallyCustomerLedger = createAsyncThunk(
  "tally/createTallyCustomerLedger",
  async (payload, toolkit) => {
    const response = await AxiosClient(
      "POST",
      `/tally/create-customer-ledger/`,
      payload,
      toolkit
    );

    return response?.payload;
  }
);

export const fetchTallyData = createAsyncThunk(
  "tally/fetchTallyData",
  async (tallyCompanyName, toolkit) => {
    const query = tallyCompanyName ? `tallyCompanyName=${encodeURIComponent(tallyCompanyName)}` : "";
    console.log('query',query)
    const response = await AxiosClient("GET", `/tally/tally-data?${query}`, {
      params: tallyCompanyName ? { tallyCompanyName } : {}
    }, toolkit);
    return response?.payload?.data;
  }
);

export const syncInvoiceWithTally = createAsyncThunk(
  "tally/syncInvoiceWithTally",
  async ({ invoiceId, tallyLedgerName }, toolkit) => {
    const payload: Record<string, string> = {};

    if (tallyLedgerName?.trim()) {
      payload.tallyLedgerName = tallyLedgerName.trim();
    }

    const response = await AxiosClient(
      "POST",
      `/tally/sync-sales-voucher/${invoiceId}`,
      payload,
      toolkit
    );

    return response?.payload;
  }
);

export const syncCreditNoteWithTally = createAsyncThunk(
  "tally/syncCreditNoteWithTally",
  async ({ creditNoteId, tallyLedgerName }, toolkit) => {
    const payload: Record<string, string> = {};

    if (tallyLedgerName?.trim()) {
      payload.tallyLedgerName = tallyLedgerName.trim();
    }

    const response = await AxiosClient(
      "POST",
      `/tally/sync-credit-note-voucher/${creditNoteId}`,
      payload,
      toolkit
    );

    return response?.payload;
  }
);

export const syncReceiptWithTally = createAsyncThunk(
  "tally/syncReceiptWithTally",
  async (
    {
      receiptId,
      isDifferentBranch,
      tallyCompanyName,
      tallyBankName,
      tallyLedgerName,
      tallyTransferLedgerName, 
    },
    toolkit
  ) => {
    const payload = {};

    if (typeof isDifferentBranch === "boolean") {
      payload.isDifferentBranch = isDifferentBranch;
    }
    
    if (tallyCompanyName?.trim()) {
      payload.tallyCompanyName = tallyCompanyName.trim();
    }

    if (tallyBankName?.trim()) {
      payload.tallyBankName = tallyBankName.trim();
    }

    if (tallyLedgerName?.trim()) {
      payload.tallyLedgerName = tallyLedgerName.trim();
    }

    if (tallyTransferLedgerName?.trim()) {
      payload.tallyTransferLedgerName = tallyTransferLedgerName.trim();
    }

    const response = await AxiosClient(
      "POST",
      `/tally/sync-receipt-voucher/${receiptId}`,
      payload,
      toolkit
    );

    return response?.payload;
  }
);